// All reducers from slices go here
import appReducer from './appSlice';
import { combineReducers } from '@reduxjs/toolkit';
// Services
import { freeTrialApi } from 'services/freeTrial';
import { loginApi } from 'services/login';
import { masterDataApi } from 'services/masterDataApi';
import navigationReducer from './navigationSlice';
import swipeclockUserReducer from './swipeclockUserSlice';
import userReducer from './userSlice';

export const rootReducer = combineReducers({
  app: appReducer,
  swipeclockUser: swipeclockUserReducer,
  navigation: navigationReducer,
  user: userReducer,
  [freeTrialApi.reducerPath]: freeTrialApi.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
  [masterDataApi.reducerPath]: masterDataApi.reducer,
});
